module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs-list",
    class: {
      'tabs-list--large': _vm.isLarge,
      'tabs-list--flat': _vm.flatDesign
    },
    attrs: {
      "role": "tablist"
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('div', {
      key: tab.id,
      class: [
        'tabs-list__tab',
        {
          'tabs-list__tab--selected': _vm.selected === tab.id,
          'tabs-list__tab--disabled': tab.disabled
        }
      ],
      attrs: {
        "role": "tab",
        "tabindex": "0",
        "aria-selected": String(_vm.selected === tab.id),
        "aria-disabled": tab.disabled ? 'true' : 'false'
      },
      on: {
        "click": function($event) {
          return _vm.onSelect(tab)
        },
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.onSelect(tab)
        }
      }
    }, [_vm._v("\n    " + _vm._s(tab.title) + "\n  ")])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d994f34a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Tabs.vue
// module id = 2135
// module chunks = 1